import { RefreshCw, WifiOff } from 'lucide-react';
import { useState } from 'react';
import { usePwa } from './pwa-context';

export function PwaStatus() {
  const { state, applyUpdate } = usePwa();
  const [updating, setUpdating] = useState(false);
  if (!state.offline && !state.updateReady) return null;
  return (
    <aside className="pwa-status" role="status" aria-live="polite">
      {state.offline && (
        <span>
          <WifiOff size={16} />
          <strong>오프라인</strong> 이 화면과 로컬 초안만 사용할 수 있습니다. 서버 제출·승인·법적
          원본 조회는 차단됩니다.
        </span>
      )}
      {state.updateReady && (
        <button
          type="button"
          disabled={updating}
          onClick={() => {
            setUpdating(true);
            void applyUpdate().catch(() => {
              setUpdating(false);
            });
          }}
        >
          <RefreshCw className={updating ? 'pwa-status__spin' : undefined} size={16} />
          {updating ? '업데이트 적용 중' : '안전하게 업데이트'}
        </button>
      )}
    </aside>
  );
}
